export const BREAKPOINTS = {
  sm: "420px",
  md: "768px",
  lg: "1024px",
  xl: "1440px",
  "2xl": "1920px",
}
